import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const entityDirectory = defineStyle({
  background: 'entityDirectory.inputBackground',
  border: '1px solid',
  borderColor: 'entityDirectory.secondaryBorder',
  borderRadius: 0,
  color: 'entityDirectory.text',
  _placeholder: { color: 'entityDirectory.mutedText' },
  _hover: { borderColor: 'entityDirectory.mutedText' },
  _focusVisible: {
    borderColor: 'entityDirectory.primaryBackground',
    boxShadow: 'none',
  },
});

export default defineStyleConfig({
  variants: { entityDirectory },
});
